import type { RouteRecordRaw, Router } from 'vue-router'

const BillRequestRoutes: RouteRecordRaw = {
  path: '/registration/bill-request',
  children: [
    {
      path: '',
      name: 'BillRequestView',
      component: () => import('./views/BillRequestView.vue'),
      meta: {
        title: 'billRequest.routeTitle',
      },
    },
    {
      path: 'create',
      name: 'CreateBillRequestView',
      component: () => import('./views/BillRequestUpsertView.vue'),
      meta: {
        title: 'createRequest',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:billRequestId',
      name: 'EditBillRequestView',
      component: () => import('./views/BillRequestUpsertView.vue'),
      meta: {
        title: 'editRequest',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:billRequestId',
      name: 'BillRequestSingleView',
      component: () => import('./views/BillRequestSingleView.vue'),
      meta: {
        title: 'viewRequest',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BillRequestRoutes)
}
